import React from 'react';
import Select from 'react-select';

const SelectCardLanguage = props => {
  const options = [
    { value: null, label: 'Todos' },
    { value: 'ESP', label: 'Español' },
    { value: 'ING', label: 'Inglés' },
    { value: 'POR', label: 'Portugués' },
    { value: 'ITA', label: 'Italiano' },
    { value: 'FRA', label: 'Francés' },
    { value: 'ALE', label: 'Alemán' },
    { value: 'RUS', label: 'Ruso' },
    { value: 'CHI', label: 'Chino' },
    { value: 'JAP', label: 'Japonés' },
    { value: 'KOR', label: 'Coreano' },
  ];

  const onChangeWrapper = selectedOptions => {
    let event = { target: {} };
    event.target.name = props.name ? props.name : 'select-nameless';

    if (selectedOptions && selectedOptions.length > 0) {
      const hasAllOption = selectedOptions.some(
        option => option.value === null,
      );
      const hasSpecificLanguages = selectedOptions.some(
        option => option.value !== null,
      );

      if (hasAllOption && hasSpecificLanguages) {
        // Check what was the previous selection to determine the user's intent
        const currentValue = props.value;
        const wasAllSelected =
          currentValue === null || currentValue === undefined;

        if (wasAllSelected) {
          // User had "Todos" selected and added a specific language - keep only specific languages
          const specificLanguages = selectedOptions.filter(
            option => option.value !== null,
          );
          event.target.value = specificLanguages.map(option => option.value);
        } else {
          // User had specific languages and selected "Todos" - keep only "Todos"
          event.target.value = null;
        }
      } else if (hasAllOption) {
        // Only "Todos" is selected
        event.target.value = null;
      } else {
        // Only specific languages are selected
        event.target.value = selectedOptions.map(option => option.value);
      }
    } else {
      event.target.value = [];
    }

    event.target.type = 'react-select-multi';
    props.onChange(event);
  };

  let value = props.value;

  if (value === null || value === undefined) {
    value = [];
  } else if (Array.isArray(value)) {
    value = options.filter(option => value.includes(option.value));
  } else {
    value = [options.find(option => option.value === value)].filter(Boolean);
  }

  return (
    <Select
      className={props.selectClassName}
      name={props.name}
      onChange={onChangeWrapper.bind(this)}
      value={value || []}
      required={props.required}
      options={options}
      isMulti={true}
      isClearable={false}
      placeholder={props.placeholder}
      menuPortalTarget={document.body}
      disabled={props.disabled}
      styles={{
        control: provided => ({
          ...provided,
          minHeight: '40px',
          padding: '0 0px',
          borderRadius: '0.375rem',
        }),
        dropdownIndicator: provided => ({
          ...provided,
          padding: '0 8px',
        }),
        clearIndicator: provided => ({
          ...provided,
          padding: '0 8px',
        }),
        input: provided => ({
          ...provided,
          padding: '0',
          margin: '0',
        }),
        multiValue: provided => ({
          ...provided,
          backgroundColor: '#e2e8f0',
          borderRadius: '0.25rem',
        }),
        multiValueLabel: provided => ({
          ...provided,
          color: '#1e293b',
        }),
        multiValueRemove: provided => ({
          ...provided,
          color: '#64748b',
          ':hover': {
            backgroundColor: '#cbd5e1',
            color: '#1e293b',
          },
        }),
      }}
    />
  );
};

export default SelectCardLanguage;
